import { render, staticRenderFns } from "./maintainanceTaskManageList.vue?vue&type=template&id=bb6c28e8&scoped=true"
import script from "./maintainanceTaskManageList.vue?vue&type=script&lang=js"
export * from "./maintainanceTaskManageList.vue?vue&type=script&lang=js"
import style0 from "./maintainanceTaskManageList.vue?vue&type=style&index=0&id=bb6c28e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6c28e8",
  null
  
)

export default component.exports